export const HEADER_HEIGHT = 48;
export const SIDE_PADDING = 8;
